import { ClientInfo, Consent, RedirectAttrs } from '../models/commonModels';
import { CommonActionRequestType, RequestType } from '../reducers/requestReducer';
import { RequestActionType } from './requestActions';

export enum ConsentActionType {
    RegisterConsentInit = 'REGISTER_CONSENT/INIT',
    GetUserConsentForClientInit = 'GET_USER_CONSENT_FOR_CLIENT/INIT',
    SetClientInfo = 'SET_CLIENT_INFO',
    SetRedirectAttrs = 'SET_REDIRECT_ATTRS',
    CheckTermsAndConditionsInit = 'CHECK_TERMS_AND_CONDITIONS/INIT',
    SetTermsAndConditionsInit = 'SET_TERMS_AND_CONDITIONS/INIT',
}

export interface SetClientInfo {
    type: ConsentActionType.SetClientInfo;
    clientInfo: ClientInfo;
}

export const setClientInfo = (clientInfo: ClientInfo): SetClientInfo => ({
    type: ConsentActionType.SetClientInfo,
    clientInfo,
});

export interface SetRedirectAttrs {
    type: ConsentActionType.SetRedirectAttrs;
    redirectAttrs: RedirectAttrs;
}
export const setRedirectAttrs = (redirectAttrs: RedirectAttrs): SetRedirectAttrs => ({
    type: ConsentActionType.SetRedirectAttrs,
    redirectAttrs,
});

export interface RegisterConsent extends CommonActionRequestType {
    type: ConsentActionType.RegisterConsentInit;
    payload: { client: RedirectAttrs; consent: Consent };
}

export const registerConsent = (payload: { client: RedirectAttrs; consent: Consent }): RegisterConsent => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.RegisterConsent,
    type: ConsentActionType.RegisterConsentInit,
    payload,
});

export interface GetUserConsentForClient extends CommonActionRequestType {
    type: ConsentActionType.GetUserConsentForClientInit;
}

export const getUserConsentForClient = (): GetUserConsentForClient => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.GetUserConsentForClient,
    type: ConsentActionType.GetUserConsentForClientInit,
});

export interface CheckTerms extends CommonActionRequestType {
    type: ConsentActionType.CheckTermsAndConditionsInit;
}

export const checkTerms = (): CheckTerms => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.CheckTermsAndConditions,
    type: ConsentActionType.CheckTermsAndConditionsInit,
});

export interface SetTerms extends CommonActionRequestType {
    type: ConsentActionType.SetTermsAndConditionsInit;
}

export const setTerms = (): SetTerms => ({
    requestActionType: RequestActionType.Init,
    requestType: RequestType.SetTermsAndConditions,
    type: ConsentActionType.SetTermsAndConditionsInit,
});

export type ConsentActions = SetClientInfo | SetRedirectAttrs;
